/** @format */
import { createSlice } from '@reduxjs/toolkit';
import { createInPersonEventObject } from '../utility/utils';

export const aem = createSlice({
  name: 'aem',
  initialState: {
    data: null,
    registerData: [],
    partnerRegisterData: [],
    spanishLang: [],
    partnerSpanishLang: [],
    FAQ: [],
    superbowlFAQ: [],
    offerData: [],
    quickTips: null,
    quickTipData: [],
    incentives: [],
    articleContent: [],
    selectedCourse: '',
    isSpanish: false,
    password: '',
    registrationStepsData: {
      token: '',
      referralCode: '',
      user: { 
        email: '',
        password: '',
        firstName:'',
        lastName:''
      },
      businessData: {
        topics: [],
        groups: [],
        city: '',
        state: '',
        zipcode: '',
        uiLocale: 'en-US',
        contentLocale: 'en-US',
        businessName: '',
      },
    },
    registerTriggeredFrom: "", //Used for holding value of the page in case user goes from register to sign in
    dateJson: "",
    aemOffersContentForHeading: {},
    currentCourse:{},
    instructorData: {},
    topics: [],
    learningFilterTopicsData: [],
    allEventsByLocation: [],
    aiCommonData: []
  },

  reducers: {
    updateAEMJsonData: (state, action) => {
      state.data = action.payload;
    },
    updateAEMOffersJsonData: (state, action) => {
      state.offerData = action.payload;
      state.aemOffersContentForHeading.resourceDetailPageOfferCTATitle = action.payload.resourceDetailPageOfferCTATitle;
      state.aemOffersContentForHeading.resourceDetailPageOfferTitle = action.payload.resourceDetailPageOfferTitle;
      state.aemOffersContentForHeading.topicPageOfferCTATitle = action.payload.topicPageOfferCTATitle;
      state.aemOffersContentForHeading.topicPageOfferTitle = action.payload.topicPageOfferTitle;
    },
    updateAEMQuickTIpsData: (state, action) => {
      state.quickTipData = action.payload;
    },
    updateAEMRegisterData: (state, action) => {
      state.registerData = action.payload;
    },
    updateAEMPartnerRegisterData: (state, action) => {
      state.partnerRegisterData = action.payload;
    },
    updateLangSpanish: (state, action) => {
      state.spanishLang = action.payload;
    },
    updateLangForPartnerSpanish: (state, action) => {
      state.partnerSpanishLang = action.payload;
    },
    addFAQ: (state, action) => {
      state.FAQ = action.payload;
    },
    addSuperbowlFAQ: (state, action) => {
      state.superbowlFAQ = action.payload;
    },
    courseCx: (state, action) => {
      state.courseCx = action.payload;
    },
    updateIncentives: (state, action) => {
      state.incentives = action.payload;
    },
    updateArticleContent: (state, action) => {
      state.articleContent.push(action.payload);
    },
    updateSpanish: (state, action) => {
      state.isSpanish = action.payload;
    },
    updateSelectedCourse: (state, action) => {
      state.selectedCourse = action.payload;
    },
    registerPassword: (state, action) => {
      state.password = action.payload;
    },
    updateRegistrationStepsData: (state, action) => {
      state.registrationStepsData = action.payload;
    },
    updateRegistrationStepTopics: (state, action) => {
      state.registrationStepsData.businessData.topics = action.payload;
    },
    updateRegistrationStepGroups: (state, action) => {
      state.registrationStepsData.businessData.groups = action.payload;
    },
    updateRegistrationStepLocation: (state, action) => {
      state.registrationStepsData.businessData.city = action.payload.city;
      state.registrationStepsData.businessData.state = action.payload.state;
      state.registrationStepsData.businessData.zipcode = action.payload.zipcode;
    },
    updateAccessId: (state, action) => {
      state.registrationStepsData.businessData.partnerAccessId = action.payload
    },
    updateRegistrationStepUserDetails: (state, action) => {
      state.registrationStepsData.user.email = action.payload.email;
      state.registrationStepsData.user.password = action.payload.password;
      state.registrationStepsData.user.firstName = action.payload.firstName;
      state.registrationStepsData.user.lastName = action.payload.lastName;
    },
    updateRegistrationStepCaptchaToken: (state, action) => {
      state.registrationStepsData.token = action.payload;
    },
    updateReferralCode: (state, action) => {
      state.registrationStepsData.referralCode = action.payload;
    },
    updateUiLocaledata: (state, action) => {
      state.registrationStepsData.businessData.uiLocale = action.payload.uiLocale;
      state.registrationStepsData.businessData.contentLocale = action.payload.contentLocale;
    },
    updateBusinessName: (state, action) => {
      state.registrationStepsData.businessData.businessName = action.payload.businessName;
    },
    updateFirstName: (state, action) => {
      state.registrationStepsData.user.firstName = action.payload.firstName;
    },
    updateLastName: (state, action) => {
      state.registrationStepsData.user.lastName = action.payload.lastName;
    },
    updateRegisterTriggeredFrom: (state, action) => {
      state.registerTriggeredFrom = action.payload;
    },
    updateDateJson: (state, action) => {
      state.dateJson = action.payload;
    },
    updateCurrentCourse: (state,action) => {
      state.currentCourse = action.payload
    },
    updateInstructor: (state,action)=>{
      state.instructorData = action.payload
    },
    updateCourseCxJsonData: (state,action)=>{
      state.courseCxJsonData = action.payload
    },
    updateEventCxJsonData: (state,action)=>{
      state.eventCxJsonData = action.payload
    },
    updateLearningPathFilters:(state,action)=>{
      state.learningFilterTopicsData = action.payload
    },
    updateAICommonData:(state,action)=>{
      state.aemAiSearchData = action.payload
    },
    updateEventStatus: (state,action)=>{
      state.eventStatus = action.payload
    },
    updateResultsTopics: (state, action) => {
      state.topics = action.payload?.allTopics;
      state.imgFormat = action.payload?.imgFormat;
      state.imgData = action.payload?.imgData;
      state.cDamDomainPath = action.payload?.cDamDomainPath;
    },
    updateInPersonEventCxJsonData: (state,action)=>{
      state.inPersonEventCxData = action.payload
    },
    updateDisplayResolution: (state, action) => {
      state.displayType = action.payload
    },
    loadAllInPersonEventsByLocation: (state, action) => {
        let allIPEventsWithTimeZone = [];
        let userLanguage = localStorage.getItem("lng") ? localStorage.getItem("lng") : 'en';
        let allIPEvents = action.payload;
        allIPEvents?.forEach((event) => {
          allIPEventsWithTimeZone.push(createInPersonEventObject(event, userLanguage));
        });
      state.allEventsByLocation = allIPEventsWithTimeZone;
    },
  },
});

export const {
  updateAEMJsonData,
  updateAEMOffersJsonData,
  updateAEMQuickTIpsData,
  updateAEMRegisterData,
  updateAEMPartnerRegisterData,
  updateLangSpanish,
  updateLangForPartnerSpanish,
  addFAQ,
  addSuperbowlFAQ,
  courseCx,
  updateIncentives,
  updateArticleContent,
  updateSelectedCourse,
  updateSpanish,
  registerPassword,
  updateRegistrationStepsData,
  updateRegistrationStepTopics,
  updateRegistrationStepGroups,
  updateRegistrationStepLocation,
  loadAllInPersonEventsByLocation,
  updateRegistrationStepUserDetails,
  updateRegistrationStepCaptchaToken,
  updateReferralCode,
  updateUiLocaledata,
  updateBusinessName,
  updateFirstName,
  updateLastName,
  updateRegisterTriggeredFrom,
  updateAccessId,
  updateDateJson,
  updateCurrentCourse,
  updateInstructor,
  updateCourseCxJsonData,
  updateEventCxJsonData,
  updateEventStatus,
  updateResultsTopics,
  updateLearningPathFilters,
  updateAICommonData,
  updateInPersonEventCxJsonData,
  updateDisplayResolution
} = aem.actions;

export default aem.reducer;
